import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Rating.scss';
export const ratingName = 'Rating';
export const ratingTagName = 'cell-component-rating';
export class Rating extends Component {
    constructor() {
        super(ratingName);
        this.validateProps(['maxRating', 'labelTemplate']);
    }
    update(data) {
        let raitingRemainder = data.rating;
        for (let i = 0; i < this.props.maxRating; i += 1) {
            // Clamp the remainder to 0-1
            const ratingIconFill = Math.min(Math.max(raitingRemainder, 0), 1);
            const ratingIconFillPercentage = `${ratingIconFill * 100}%`;
            this.iconElements[i]
                ?.querySelector('linearGradient stop:nth-child(1)')
                ?.setAttribute('offset', `${ratingIconFillPercentage}`);
            this.iconElements[i]
                ?.querySelector('linearGradient stop:nth-child(2)')
                ?.setAttribute('offset', `${ratingIconFillPercentage}`);
            raitingRemainder -= 1;
        }
        this.labelTextElement.textContent = this.props.labelTemplate
            .replace('%rating%', this.normalizeRating(data.rating).toString())
            .replace('%rating_max%', this.normalizeRating(this.props.maxRating).toString())
            .replace('%rating_count%', data.ratingCount.toString());
    }
    showSkeleton(show) {
        this.classList.toggle('Rating--Skeleton', show);
    }
    /**
     * Normalizes the rating to a string with a precision of 1.
     */
    normalizeRating(num) {
        return num.toFixed(1);
    }
    get iconElements() {
        return this.querySelectorAll('.Rating__Icon');
    }
    get labelTextElement() {
        const labelTextElement = this.querySelector('.Rating__Label')?.children[0];
        if (!labelTextElement) {
            throw new Error('Label element not found');
        }
        return labelTextElement;
    }
}
defineComponent(ratingTagName, Rating);
